import React, {Component} from "react"

class IBox extends Component {



  render() {

    const className = this.props.className || ''

    const title = this.props.title ?
      <div className="ibox-title">
        <h5>{this.props.title}</h5>
      </div> : ""

    return (


      <div className={`ibox float-e-margins ${className}`}>
        {title}
        <div className="ibox-content">
          {this.props.children}
        </div>
      </div>


    )
  }
}

export default IBox



// WEBPACK FOOTER //
// ./src/components/IBox.js